module.exports = __webpack_public_path__ + "img/1-1P61ZS332192.46a3cb76.png";